<template>
    <DashboardShell :api="api" :lang="language" />
</template>

<script>
    import { mapGetters } from 'vuex'
    import DashboardShell from '@/components/app/dashboard/DashboardShell.vue'
    import { dashboardApi } from '@/services/DashboardService.js'

    // one page component serves every dashboard route (dashboard, dashboard-indicators, ...),
    // so vue-router reuses this instance and the loaded snapshot survives tab switches
    export default {
        components: {
            DashboardShell
        },

        data() {
            return {
                api: dashboardApi
            }
        },

        computed: {
            ...mapGetters('user', ['language'])
        }
    }
</script>
